import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  themeId: z.string(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
};

export const deleteTheme = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const result = await fetch('/_api/themes/delete', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
